var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetadata(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5H9V3H7V5ZM7 13H9V11H7V13ZM7 21H9V19H7V21ZM11 17H13V15H11V17ZM11 21H13V19H11V21ZM3 21H5V19H3V21ZM3 17H5V15H3V17ZM3 13H5V11H3V13ZM3 9H5V7H3V9ZM3 5H5V3H3V5ZM11 13H13V11H11V13ZM19 17H21V15H19V17ZM19 13H21V11H19V13ZM19 21H21V19H19V21ZM19 9H21V7H19V9ZM11 9H13V7H11V9ZM19 3V5H21V3H19ZM11 5H13V3H11V5ZM15 21H17V19H15V21ZM15 13H17V11H15V13ZM15 5H17V3H15V5Z",
    fill: "#7F8090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H7V7H9V9Z",
    fill: "#7F8090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17H7V15H9V17Z",
    fill: "#7F8090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H15V15H17V17Z",
    fill: "#7F8090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9H15V7H17V9Z",
    fill: "#7F8090"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetadata);
export default __webpack_public_path__ + "static/media/metadata.71c05ce4.svg";
export { ForwardRef as ReactComponent };